
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { BusinessSignalrService } from 'src/app/services/signalr.service';
import { NotificationState } from 'src/app/store-ngxs/states/notification.state';
import {
  LoadNotifications,
  LoadUnreadCount,
  ReceiveRealtimeNotification,
} from 'src/app/store-ngxs/actions/notification.actions';
import { UserNotification } from 'src/app/models/notification.model';
import { LabelKeys } from 'src/app/models/enums/label-keys';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-horizontal-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HorizontalHeaderComponent implements OnInit, OnDestroy {
  notifKeys = LabelKeys.notifications;
  commonKeys = LabelKeys.common;
  @Input() secondaryNavigation: any[] = [];
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Espanol',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Francais',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  unreadCount$: Observable<number>;
  latestNotifications$: Observable<UserNotification[]>;

  private signalrSub: Subscription;

  constructor(
    private store: Store,
    private signalrService: BusinessSignalrService,
    private router: Router,
    private authService: AuthService
  ) {
    this.unreadCount$ = this.store.select(NotificationState.getUnreadCount);
    this.latestNotifications$ = this.store.select(
      NotificationState.getLatestNotifications
    );
  }

  ngOnInit(): void {
    this.store.dispatch(new LoadUnreadCount());
    this.store.dispatch(new LoadNotifications({ page: 1, pageSize: 5 }));

    this.signalrSub = this.signalrService.notificationReceived.subscribe(
      (notification) => {
        if (notification) {
          this.store.dispatch(new ReceiveRealtimeNotification(notification));
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.signalrSub) {
      this.signalrSub.unsubscribe();
    }
  }

  changeLanguage(lang: any): void {
    this.selectedLanguage = lang;
  }

  onNotificationClick(notification: UserNotification): void {
    if (notification.applicationTypeId && notification.appDataId) {
      this.router.navigate(['/app/applications'], {
        queryParams: {
          typeId: notification.applicationTypeId,
          highlightUuid: notification.appDataId,
        },
      });
    }
  }

  goToInbox(): void {
    this.router.navigate(['/app/inbox']);
  }

  logout(): void {
    this.authService.logout();
  }
}
